var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0.75V2.25H2.25C1.83579 2.25 1.5 2.58579 1.5 3V15C1.5 15.4142 1.83579 15.75 2.25 15.75H8.06595C7.24254 14.7228 6.75 13.4189 6.75 12C6.75 8.68628 9.43628 6 12.75 6C14.1689 6 15.4728 6.49254 16.5 7.31597V3C16.5 2.58579 16.1642 2.25 15.75 2.25H12.75V0.75H11.25V2.25H6.75V0.75H5.25ZM17.25 12C17.25 14.4853 15.2353 16.5 12.75 16.5C10.2647 16.5 8.25 14.4853 8.25 12C8.25 9.51472 10.2647 7.5 12.75 7.5C15.2353 7.5 17.25 9.51472 17.25 12ZM12 9V12.3106L13.7197 14.0303L14.7803 12.9697L13.5 11.6894V9H12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar3);
export default __webpack_public_path__ + "static/media/calendar3.14e1279fe721124d1a634662b0a0c464.svg";
export { ForwardRef as ReactComponent };